import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createFacilityArea,
  updateFacilityArea,
  getFacilityAreaById,
  getFacilityAreas,
  getAreasRating,
} from '../../axios/facilityAreaRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IFacilitiesAreasStore,
  FacilityArea,
  AreaRating,
} from '../storeInterfaces/facilityAreaInterface';
import { RequestStatus } from 'mobx-store';

export class FacilityAreaStore implements IFacilitiesAreasStore {
  @observable facilitiesAreas: FacilityArea[] = [];

  @observable selectedFacilityArea = {};

  @observable loading = false;

  @observable areasRating: AreaRating[] = [];

  @observable getFacilitiesAreasRequestStatus: RequestStatus = RequestStatus.IDLE;

  private static restructureFacilityArea(facilityArea: FacilityArea): any {
    return {
      facilityAreaId: facilityArea.facilityAreaId,
      title: facilityArea.title,
      branchId: facilityArea.branch.branchId,
    };
  }

  private static restructureFacilityAreasList(categories: FacilityArea[]): any[] {
    return categories.map((facilityArea: FacilityArea) => ({
      ...facilityArea,
      branchId: facilityArea.branch.branchId,
    }));
  }

  @action
  public async getAreasRating(branchId: number, countries: ICountry[]): Promise<any> {
    try {
      this.loading = true; 
      this.getFacilitiesAreasRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);
      const response = await Connections.wadiDeglaAxios.httpGet(getAreasRating(branchId), {
        params: {
          availableCountries
        }
      });      
      this.areasRating = response.data;
      this.getFacilitiesAreasRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFacilitiesAreasRequestStatus = RequestStatus.FAILED;
      console.log(error);
      Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getFacilityAreas(countries: ICountry[], langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getFacilitiesAreasRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
      };

      const config = {
        ...getHeader(langCode), params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getFacilityAreas, config);
      this.facilitiesAreas = FacilityAreaStore.restructureFacilityAreasList(response.data);
      this.getFacilitiesAreasRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFacilitiesAreasRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getFacilityAreaById(id: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getFacilityAreaById(id), getHeader(langCode));
      this.selectedFacilityArea = FacilityAreaStore.restructureFacilityArea(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createFacilityArea(newFacilityArea: FacilityArea, langCode: string = DefaultLanguage): Promise<number> {
    return new Promise<number>(async (res, rej) => {
      try {
        const response = await Connections.wadiDeglaAxios.httpPost(createFacilityArea, newFacilityArea, getHeader(langCode));
        res(response.data.facilityAreaId);
      } catch (error) {
        rej(error);
      }
    });
  }

  @action.bound
  public async updateFacilityArea(updatedFacilityArea: FacilityArea, FacilityAreaId: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateFacilityArea(FacilityAreaId), updatedFacilityArea, getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }
}
